import { createContext } from 'react';

const initialState = {
    local: {
        isUserProfileEntityFeatureEnabled: true
    },
    dev: {
        isUserProfileEntityFeatureEnabled: true
    },
    test: {
        isUserProfileEntityFeatureEnabled: true
    },
    production: {
        isUserProfileEntityFeatureEnabled: true
    }
}

const FeatureFlagContext = createContext(initialState);

export const FeatureFlagProvider = ({ children }) => {
    return (
        <FeatureFlagContext.Provider value={initialState}>
            {children}
        </FeatureFlagContext.Provider>
    )
}

export default FeatureFlagContext;